export default {
  en: {
    'components.navigation-prompt.message':
      'You have unsaved changes. Are you sure you want to leave?',
  },
};
